import { Client } from './client';
import { CreditNote } from './creditNote';
import { Department } from './department';
import { Money } from './entity';

export enum MATCHED_STATUS {
  FULLY_PAID = 'fully_paid',
  FULLY_CREDITED = 'fully_credited',
  MIXED = 'mixed',
  UNMATCHED = 'unmatched',
}

interface BaseInvoice {
  id: string;
  department: Department;
  invoiceNumber: string;
  total: {
    due: Money;
    payable: Money;
  };
  dueDate: string;
  matchedStatus: MATCHED_STATUS;
}

export interface Invoice extends BaseInvoice {
  department: Department;
  creditNotes: CreditNote[];
  client: Client;
  paidAt: string | null;
  total: {
    due: Money;
    payable: Money;
    interest: Money;
    fixedLateFee: Money;
    paidAmount: Money;
    creditedAmount: Money;
  };
}

export type ListInvoice = BaseInvoice;
